<template>
  <div class="field">
    <dl>
      <dd>{{ label }}</dd>
      <dt>
        <slot name="fieldContent"></slot>
      </dt>
    </dl>
  </div>
</template>

<script>
export default {
  name: "BaseField",
  props: {
    label: {
      type: String,
    },
  },
};
</script>
